import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { AquatecSystemApiEnum } from 'submodules/nerit-aquatec-sdk/common/AquatecSystemApiEnum'
import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { DataAnalysisSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/data-analysis/dtos/request/DataAnalysisSearchRequestDTO'
import { DeleteFieldValuesRequestDTO } from 'submodules/nerit-aquatec-sdk/services/data-analysis/dtos/request/DeleteFieldValuesRequestDTO'
import { DataAnalysisListItemResponseDTO } from 'submodules/nerit-aquatec-sdk/services/data-analysis/dtos/response/DataAnalysisListItemResponseDTO'
import { ListResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/ListResponseDTO'
import { FieldValueSaveRequestDTO } from 'submodules/nerit-aquatec-sdk/services/data-analysis/dtos/request/FieldValueSaveRequestDTO'
/*
import { DataAnalysisSamplingDataResponseDTO } from 'submodules/nerit-aquatec-sdk/services/data-analysis/dtos/response/DataAnalysisSamplingDataResponseDTO'
*/
export class DataAnalysisRequests {

    public static CONTROLLER_ROOT = 'data-analysis'
    public static SEARCH_EP = 'search'
    public static SEARCH_EXPORT_EP = 'search-export'
    public static SEARCH_EXPORT_SIMPLE_EP = 'search-export-simple'
    public static GET_SAMPLING_DATA_EP = 'get-sampling-data'

    public static UPDATE_MEASUREMENT_DATA_EP = 'update-measuremente-data/:fieldValueCode'
    public static DELETE_MEASUREMENT_DATA_EP = 'remove-measuremente-data/:fieldValueCode'
	public static DELETE_FIELD_VALUES_EP = 'delete-field-values'

    static search = (dto: DataAnalysisSearchRequestDTO): RequestConfigTP<ListResponseDTO<DataAnalysisListItemResponseDTO>> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DataAnalysisRequests.CONTROLLER_ROOT}/${DataAnalysisRequests.SEARCH_EP}`,
        method: HttpMethodEnum.GET,
        params: dto,
    })

	static searchExport = (dto: DataAnalysisSearchRequestDTO): RequestConfigTP<'blob'> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${DataAnalysisRequests.CONTROLLER_ROOT}/${DataAnalysisRequests.SEARCH_EXPORT_EP}`,
		method: HttpMethodEnum.GET,
		params: dto,
		responseType: 'blob',
	})

    static searchExportSimple = (dto: DataAnalysisSearchRequestDTO): RequestConfigTP<'blob'> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DataAnalysisRequests.CONTROLLER_ROOT}/${DataAnalysisRequests.SEARCH_EXPORT_SIMPLE_EP}`,
        method: HttpMethodEnum.GET,
        params: dto,
        responseType: 'blob',
    })
/*
A chamada de filtro de campanha é feita através do ChartsRequests
    static getSamplingData = (samplingCodes: number[]): RequestConfigTP<DataAnalysisSamplingDataResponseDTO> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DataAnalysisRequests.CONTROLLER_ROOT}/${DataAnalysisRequests.GET_SAMPLING_DATA_EP}`,
        method: HttpMethodEnum.GET,
        params: { samplingCodes },
    })
*/
    static updateMeasurement = (fieldValueCode: number, dto: FieldValueSaveRequestDTO): RequestConfigTP<FieldValueSaveRequestDTO> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DataAnalysisRequests.CONTROLLER_ROOT}/${DataAnalysisRequests.UPDATE_MEASUREMENT_DATA_EP.replace(':fieldValueCode', fieldValueCode.toString())}`,
        method: HttpMethodEnum.PUT,
        params: dto
    })

    static deleteMeasurement = (fieldValueCode: number): RequestConfigTP<FieldValueSaveRequestDTO> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DataAnalysisRequests.CONTROLLER_ROOT}/${DataAnalysisRequests.DELETE_MEASUREMENT_DATA_EP.replace(':fieldValueCode', fieldValueCode.toString())}`,
        method: HttpMethodEnum.DELETE,
    })

	static deleteFieldValues = (dto: DeleteFieldValuesRequestDTO): RequestConfigTP<void> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DataAnalysisRequests.CONTROLLER_ROOT}/${DataAnalysisRequests.DELETE_FIELD_VALUES_EP}`,
        method: HttpMethodEnum.DELETE,
        params: dto
    })

}